import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import Clarity from '@microsoft/clarity'
import { env } from './env'

switch (env.REACT_APP_AWS_ENVIRONMENT) {
  case 'prod-classranked':
    Clarity.init('qxdwlcwzvl')
    break
  case 'test-classranked':
    Clarity.init('qxdxcwkute')
    break
  case 'dev-classranked':
    Clarity.init('qxdx88v9ma')
    break
  default:
    break
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)
root.render(
  <React.StrictMode>
        <App />
   </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
